import { LoanSchedule } from "@/modules/loan/components";
import { PageHeader } from "@/shared/components";

export const LoanSchedulePage = () => {
  return (
    <div className="full-width page-container">
      <PageHeader/>
      <LoanSchedule/>
    </div>
  );
};
